<template>
   <div >
    <el-form
      class="form-wrap step-one"
      ref="editMeetingForm"
      :model="editMeetingForm"
      :rules="editMeetingFormRules"
      label-position="top"
      style="margin:0 20px;width: 380px;padding-top: 5px;"
    >
      <el-row type="flex" justify="center">
        <el-col :span="24" class="form-items">
          <el-form-item label="Meeting Name" prop="Title">
            <el-input
              v-model="editMeetingForm.Title"
              placeholder="Please enter the meeting name"
              v-bind:disabled="this.editContent || disableForEdit ||disabled"
              maxlength="30"
            />
          </el-form-item>
          <el-row type="flex" align="bottom" :gutter="10">
            <el-col :span="24">
              <el-form-item prop="StartDate" label="Start Time">
                <el-date-picker
                  class="date-picker"
                  value-format="yyyy-MM-dd"
                  v-model="editMeetingForm.StartDate"
                  type="date"
                  placeholder="Select date"
                  :picker-options="startDatePickerOptions"
                  :editable="false"
                  @change="onStartDateChange"
                  v-bind:disabled="this.edit || this.editContent || disableForEdit ||disabled"
                  :clearable="false"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="StartTime">
                <el-time-select
                  class="time-selecter"
                  v-model="editMeetingForm.StartTime"
                  :picker-options="startTimePickerOptions"
                  :editable="false"
                  placeholder="Select period"
                  value-format="HH:mm"
                  @change="onStartTimeChange"
                  v-bind:disabled="this.edit || this.editContent || disableForEdit ||disabled"
                  :clearable="false"
                  ref="startTime"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="float: left">
            <p v-if="startTimePrompt" :visible="startTimePrompt" class="startP">
              The start time must be greater than current time
            </p>
          </el-row>
          <el-row type="flex" align="bottom" style="margin-top: 2%" :gutter="10">
            <el-col :span="24">
              <el-form-item label="End Time" prop="EndDate">
                <el-date-picker
                  class="date-picker"
                  value-format="yyyy-MM-dd"
                  v-model="editMeetingForm.EndDate"
                  type="date"
                  disabled
                  :editable="false"
                  placeholder="Select date"
                  :picker-options="endDatePickerOptions"
                  :clearable="false"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="EndTime">
                <el-time-select
                  class="time-selecter"
                  v-model="editMeetingForm.EndTime"
                  :picker-options="endTimePickerOptions"
                  :editable="false"
                  placeholder="Select period"
                  v-bind:disabled="this.edit || this.editContent || disableForEdit ||disabled"
                  :clearable="false"
                  ref="endTime"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="float: left">
            <p v-if="endTimePrompt" :visible="endTimePrompt" class="startP">
              The meeting time cannot be longer than 4 hours
            </p>
          </el-row>
          <el-row style="float: left; width: 100%; margin-top: 3%">
            <el-form-item prop="Status" label="Status">
              <el-select
                v-model="editMeetingForm.Status"
                v-bind:disabled="this.createStatus || disabled"
                @change="validateComment"
              >
                <el-option
                  v-for="itemStatus in meetingStatus"
                  :key="itemStatus.ParamID"
                  :label="itemStatus.ParamValue"
                  :value="itemStatus.ParamID"
                  style="text-align: left"
                  :disabled="itemStatus.ParamID == 6 ? true : false  "
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-row>
          <el-form-item prop="CommentDetail" label="Comments">
            <el-input
              v-model="editMeetingForm.CommentDetail"
              placeholder="Please fill in the comments"
              :maxlength="100"
              :disabled="disableForEdit ||disabled"
            />
          </el-form-item>
          <el-form-item
            prop="ProdInfo"
            label="Product Info"
            v-if="this.edit || this.editContent"
          >
            <el-input
              v-model="editMeetingForm.ProdInfo"
              v-bind:disabled="this.edit || this.editContent || disableForEdit ||disabled"
            />
          </el-form-item>
          <el-form-item
            prop="Source"
            label="Source"
            v-if="this.edit || this.editContent"
          >
            <el-input
              v-model="editMeetingForm.Source"
              v-bind:disabled="this.edit || this.editContent || disableForEdit ||disabled"
            />
          </el-form-item>
          <el-form-item
            prop="QuestionInfo"
            label="Question"
            v-if="this.edit || this.editContent"
          >
            <el-input
              v-model="editMeetingForm.QuestionInfo"
              v-bind:disabled="this.edit || this.editContent || disableForEdit ||disabled"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" :gutter="20">
        <el-col :span="24" class="form-items">
          <el-form-item prop="Password" label="Joining Password(optional)">
            <el-input
              v-model="editMeetingForm.Password"
              @input="onPassInput"
              disabled
              placeholder="Please enter 4~6 digital password"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="center" :gutter="20">
        <el-col :span="24" class="form-items">
          <el-form-item prop="WaitingRoom">
            <el-checkbox v-model="editMeetingForm.WaitingRoom" :disabled="disableForEdit">
              Open waiting room
            </el-checkbox>
          </el-form-item>
          <el-form-item prop="WaterPrint">
            <el-checkbox v-model="editMeetingForm.WaterPrint" :disabled="disableForEdit">
              Turn on screen watermark
            </el-checkbox>
          </el-form-item>
          <el-form-item prop="JoinMute">
            <el-checkbox v-model="editMeetingForm.JoinMute" :disabled="disableForEdit">
              Automatically mute when members join a meeting
            </el-checkbox>
          </el-form-item>
          <el-form-item prop="JoinBeforeHost">
            <el-checkbox v-model="editMeetingForm.JoinBeforeHost" :disabled="disableForEdit">
              Allow members to join the meeting before the host enters
            </el-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-top: 28px;text-align: center;">
      <el-button type="primary" @click="handleEdit">
        {{ actionLabel }}
      </el-button>
      <!-- <el-button plain @click="onClosed"> Cancel </el-button> -->
    </div>
  </div>
</template>

<script>
import { deepClone } from "../../utils";
import { getTimes } from "../../utils/datetime";
import { trimValidate } from "../../utils/validator";
import moment from "moment";
export default {
  name: "edit-meeting-dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    data: Object,
    status: null,
    refreshList: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var validateComment = (rule, value, callback) => {
      if (
        (this.editMeetingForm.Status == 2 ||
          this.editMeetingForm.Status == 5) &&
        (value == "" || value == undefined)
      ) {
        callback(new Error("Please fill in the Comments"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value && (value.length < 4 || value.length > 6)) {
        callback(new Error("Password must be 4-6 digits"));
      } else {
        callback();
      }
    };
    return {
      dateFormat: "YYYY-MM-DD",
      timeFormat: "HH:mm",
      dateTimeFormat: "YYYY-MM-DD HH:mm",
      dialogVisible: this.visible,
      meetingStatus: [],
      edit: false, //标记Approve request 时显示字段
      createStatus: false, //区分Status是否可编辑
      editContent: false, //区分Edit页面中Product Info,Sourec,Question字段是否显示
      startTimePrompt: false,
      endTimePrompt: false,
      loading: false,
      editMeetingForm: {
        //详细页面数据源
        MeetingId: "", //会议ID - 自动生成ID
        Title: "", //会议名称
        Status: "", //状态
        StartTime: "", //开始时间
        EndTime: "", //结束时间
        Comments: "",
        Password: "", //保密
        WaitingRoom: false, //开启等候室
        JoinBeforeHost: "", //允许在主持人进入会议前加入
        JoinMute: "", //加入时自动静音
        WaterPrint: true, //开启水印
        CreateDt: "",
        ModifyDt: "",
        StartDate: "", //开始时间
        EndDate: "",
        reqId: "",
        QuestionInfo: "",
        ProdInfo: "",
        Source: "",
        CommentDetail: "",
      },
      editMeetingFormRules: {
        Title: [
          {
            required: true,
            validator: trimValidate("Please fill in the Meeting Name"),
            trigger: "blur",
          },
        ],
        CommentDetail: [{ validator: validateComment, trigger: "blur" }],
        StartDate: [
          {
            required: true,
            message: "Please select start date",
            trigger: "blur",
          },
        ],
        StartTime: [
          {
            required: true,
            message: "Please select start time",
            trigger: "blur",
          },
        ],
        EndDate: [
          {
            required: true,
            message: "Please select end date",
            trigger: "blur",
          },
        ],
        EndTime: [
          {
            required: true,
            message: "Please select end time",
            trigger: "blur",
          },
        ],
        Password: [
          {
            validator: validatePass,
            trigger: "blur",
          },
        ],
      },
      startDatePickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      timeOptions: {
        start: "00:00",
        step: "00:15",
        end: "23:45",
        minTime: "00:00",
      },
      confirmAction: false,
    };
  },
  created() {
    this.getMeetingStatus("");
  },
  computed: {
    dialogTitle() {
      return this.status || !this.data
        ? "Create a Meeting"
        : "Update a Meeting";
    },
    disableForEdit() {
      if (this.data) {
        return moment().isAfter(moment(this.data.EndTime));
      } else return false;
    },
    actionLabel() {
      return this.status || !this.data ? "Create meeting" : "Save meeting";
    },
    // 开始时间过滤器
    startTimePickerOptions() {
      let options = { ...this.timeOptions };
      let startDate = this.editMeetingForm.StartDate;
      const nowDate = moment();
      let currentDate = nowDate.format(this.dateFormat);
      // 如果选择的开始日期为当前日期，那么当前时间之前的时间不可选，否则可选，但不包括前一天的时间
      if (startDate && startDate === currentDate) {
        let minTime = nowDate.format(this.timeFormat);
        let minutes = nowDate.minutes();
        minTime =
          minutes % 10 == 0 || minutes % 10 == 5
            ? nowDate.subtract(1, "minutes").format(this.timeFormat)
            : minTime;
        options.minTime = minTime;
      } else {
        options.minTime = "";
      }
      options.end = "23:30";
      return options;
    },
    // 结束时间过滤器
    endTimePickerOptions() {
      let options = { ...this.timeOptions };
      const nowDate = moment();
      let StartDate =
        this.editMeetingForm.StartDate || nowDate.format(this.dateFormat);
      let StartTime =
        this.editMeetingForm.StartTime || nowDate.format(this.timeFormat);
      const currentDatetime = moment(`${StartDate} ${StartTime}`);
      const futureDatetime = this.addMinutes(`${StartDate} ${StartTime}`, 241);
      // 如果开始时间 +4 小时大于今天，最大时间是23：45，否则当前时间 +4
      if (futureDatetime.isAfter(currentDatetime, "day")) {
        options.maxTime = "24:00";
      } else {
        options.maxTime = futureDatetime.format(this.timeFormat);
      }
      options.minTime = currentDatetime.format(this.timeFormat);
      return options;
    },
    // 结束日期过滤器
    endDatePickerOptions() {
      return {
        disabledDate: (time) => {
          // 如果选择了开始日期，那么结束日期就不能选择开始日期之前的时间，否则默认为当前日期之前的时间不可选
          let startDate = this.editMeetingForm.StartDate;
          let nowTime = startDate ? new Date(startDate).getTime() : Date.now();
          return (
            time.getTime() < nowTime - 24 * 60 * 60 * 1000 ||
            time.getTime() > nowTime + 24 * 60 * 60 * 1000
          );
        },
      };
    },
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    // 给指定时间相加15分钟
    addMinutes(date, minutes, formatTime) {
      let _date = moment(date).add(minutes, "minutes");
      return formatTime ? _date.format(this.timeFormat) : _date;
    },
    onClosed() {
      this.editMeetingForm.Title = ''
      this.editMeetingForm.CommentDetail =''
      if (!this.confirmAction) {
        this.$emit("update:visible", false);
        this.$emit("update:data", null);
        this.$refs.editMeetingForm.resetFields();
        this.createStatus = false;
        this.resetFields();
        this.startTimePrompt = false;
        this.endTimePrompt = false;
        this.editContent = false;
      }
    },
    resetFields() {
      let keys = Object.keys(this.editMeetingForm);
      for (let i in keys) {
        if (keys[i] === "WaitingRoom" || keys[i] === "WaterPrint") {
          this.editMeetingForm[keys[i]] = true;
        } else {
          this.editMeetingForm[keys[i]] = "";
        }
      }
    },
    onPassInput(value) {
      let val = value.replace(/\D/g, "");
      if (val.length > 6) {
        val = val.slice(0, 6);
      }
      this.editMeetingForm.Password = val;
    },
    onOpen() {
      if (!this.confirmAction) {
        this.$nextTick(() => {
          this.initForm();
        });
      }
      this.confirmAction = false;
    },
    initForm() {
      this.getMeetingStatus("");
      if (this.data) {
        let _data = deepClone(this.data);
        // request approved
        if (this.status == "approved") {
          this.edit = true;
          this.createStatus = true;
          _data.JoinMute = false;
          _data.JoinBeforeHost = false;
          _data.WaitingRoom = false;
          _data.WaterPrint = true;
          _data.Status = 0;

          let startDate = moment(new Date(_data.TimeSlot));
          this.editMeetingForm.StartDate = startDate.format(this.dateFormat);
          this.editMeetingForm.StartTime = startDate.format(this.timeFormat);
          let endDate = moment(_data.TimeSlot).add(
            parseInt(_data.Duration),
            "minutes"
          );
          this.editMeetingForm.EndDate = endDate.format(this.dateFormat);
          this.editMeetingForm.EndTime = endDate.format(this.timeFormat);
          this.editMeetingForm.reqId = _data.Id;

          Object.assign(this.editMeetingForm, _data);
          this.editMeetingForm.Status = "Open";
          this.editMeetingForm.Source = "RTMS";
        } else {
          // meeting编辑
          if (_data.Source == "MeetingDefault") {
            this.editContent = false;
            _data.Source = "自创建";
          }
          if (_data.Source == "MedicalEnquiry") {
            this.editContent = true;
            _data.Source = "RTMS";
          }
          this.editMeetingForm.JoinMute = _data.JoinMute;
          if (_data.JoinMute != "1") {
            _data.JoinMute = false;
          } else {
            _data.JoinMute = true;
          }

          this.editMeetingForm.IsRecurrent = _data.IsRecurrent;
          if (_data.IsRecurrent != "1") {
            _data.IsRecurrent = false;
          } else {
            _data.IsRecurrent = true;
          }

          this.editMeetingForm.WaitingRoom = _data.WaitingRoom;
          if (_data.WaitingRoom != "1") {
            _data.WaitingRoom = false;
          } else {
            _data.WaitingRoom = true;
          }

          this.editMeetingForm.JoinBeforeHost = _data.JoinBeforeHost;
          if (_data.JoinBeforeHost != "1") {
            _data.JoinBeforeHost = false;
          } else {
            _data.JoinBeforeHost = true;
          }

          this.editMeetingForm.WaterPrint = _data.WaterPrint;
          if (_data.WaterPrint != "1") {
            _data.WaterPrint = false;
          } else {
            _data.WaterPrint = true;
          }

          this.editMeetingForm.Simultaneous = _data.Simultaneous;
          if (_data.Simultaneous != "1") {
            _data.Simultaneous = false;
          } else {
            _data.Simultaneous = true;
          }

          let startDate = moment(new Date(_data.StartTime));
          let endDate = moment(new Date(_data.EndTime));
          _data.StartDate = startDate.format(this.dateFormat);
          _data.StartTime = startDate.format(this.timeFormat);
          _data.EndDate = endDate.format(this.dateFormat);
          _data.EndTime = endDate.format(this.timeFormat);

          this.editMeetingForm.CommentDetail = _data.CommentDetail;
          //this.editMeetingForm.Status = _data.Status;
          let keys = Object.keys(this.editMeetingForm);
          for (let i in keys) {
            this.editMeetingForm[keys[i]] = _data[keys[i]];
          }
          for (var item of this.meetingStatus) {
            var statusId = item.ParamID;
            if (statusId == _data.Status) {
              this.editMeetingForm.Status = item.ParamID;
            }
          }
        }
      } else {
        // 创建meeting
        this.createStatus = true;
        this.editMeetingForm.WaitingRoom = false;
        this.editMeetingForm.WaterPrint = true;
        this.editMeetingForm.JoinBeforeHost = false;
        this.editMeetingForm.JoinMute = false;
        this.editMeetingForm.AssignedHost = localStorage.getItem("userId");
        this.editMeetingForm.Status = "Open";

        const nowDate = moment();
        const currentDate = nowDate.format(this.dateFormat);
        this.editMeetingForm.StartDate = currentDate;
        this.editMeetingForm.EndDate = currentDate;
        let minTime = nowDate.format(this.timeFormat);
        // 如果时间的分刚好为00，15，30，45时，将当前分钟减一分钟

        let minutes = nowDate.minutes();
        minTime =
          minutes % 10 == 0 || minutes % 10 == 5
            ? nowDate.subtract(1, "minutes").format(this.timeFormat)
            : minTime;
        const maxTime = this.addMinutes(`${currentDate} ${minTime}`, 15, true);
        const { start, end, step } = this.timeOptions;
        const times = getTimes(start, end, step, minTime, maxTime);
        const startTime = times.find((x) => !x.disabled);
        const startTimeVal = startTime.value;
        this.editMeetingForm.StartTime = startTimeVal;
        this.editMeetingForm.EndTime = this.addMinutes(
          `${currentDate} ${startTimeVal}`,
          15,
          true
        );
      }
    },
    onStartDateChange(date) {
      // 同步结束日期为当前选择日期，即，开始日期和结束日期保持一致
      const endTime = this.editMeetingForm.EndTime;
      const StartTime = this.editMeetingForm.StartTime;
      // 修改后的开始时间小于当前时间，弹出提示
      if (moment(`${date} ${StartTime}`) < Date.now()) {
        this.startTimePrompt = true;
      } else {
        this.startTimePrompt = false;
      }
      // 如果结束时间为00:00,则日期加一天
      this.updateEndDate(date, date, endTime);
    },
    onStartTimeChange(time) {
      const StartDate = this.editMeetingForm.StartDate;
      const EndDate = this.editMeetingForm.EndDate;
      const EndTime = this.editMeetingForm.EndTime;
      // 如果开始时间 和 结束时间 的差大于240，则调整结束时间为开始时间+15分钟,  否则不变
      const startDatetime = moment(`${StartDate} ${time}`);
      const endDatetime = moment(`${EndDate} ${EndTime}`);
      const diff = endDatetime.diff(startDatetime, "minutes");
      // 如果选择开始时间和结束时间相差大于4小时，或者选中开始时间和结束时间一样，或开始时间大于结束时间（diff小于零），则调整结束时间为选中时间+15分钟
      if (diff > 240 || diff == 0 || diff < 0) {
        let endTime = this.addMinutes(startDatetime, 15, true);
        this.editMeetingForm.EndTime = endTime;

        // 如果结束时间为00:00,则日期加一天
        this.updateEndDate(StartDate, EndDate, endTime);
      }
      // 修改后的开始时间小于当前时间，弹出提示
      if (moment(`${StartDate} ${time}`) < Date.now()) {
        this.startTimePrompt = true;
      } else {
        this.startTimePrompt = false;
      }
    },
    updateEndDate(startDate, endDate, time) {
      if (time === "00:00") {
        this.editMeetingForm.EndDate = moment(endDate)
          .add(1, "days")
          .format(this.dateFormat);
      } else {
        this.editMeetingForm.EndDate = startDate;
      }
    },
    validateComment(Status) {
      if (Status == 2 || Status == 5) {
        this.$refs.editMeetingForm.validateField("CommentDetail");
      } else {
        this.$refs.editMeetingForm.clearValidate("CommentDetail");
      }
    },
    handleEdit() {
      if (this.startTimePrompt == true || this.endTimePrompt == true) {
        return;
      }
      this.$refs.editMeetingForm.validate((valid) => {
        if (valid) {
          this.confirmAction = true;
          setTimeout(() => {
            this.dialogVisible = false;
          }, 50);
          this.$confirm(
            "Please make sure if it is ready to submit?",
            "Attention",
            {
              confirmButtonText: "Confirm",
              cancelButtonText: "Cancel",
            }
          )
            .then(() => {
              this.dialogVisible = true;
              const loading = this.$loading({
                lock: true,
                text: "Saving",
                customClass: "meeting-save-loading",
                target: document.querySelector(
                  ".edit-meeting-dialog .el-dialog"
                ),
              });
              if (this.status == "approved") {
                this.axios
                  .post("/meetingReq/approve", {
                    reqId: this.editMeetingForm.reqId,
                    Title: this.editMeetingForm.Title,
                    Status: 0,
                    Owner: this.editMeetingForm.Owner,
                    StartTime:
                      this.editMeetingForm.StartDate +
                      " " +
                      this.editMeetingForm.StartTime,
                    EndTime:
                      this.editMeetingForm.EndDate +
                      " " +
                      this.editMeetingForm.EndTime,
                    CommentDetail: this.editMeetingForm.CommentDetail,
                    Passport: this.editMeetingForm.Password,
                    WaitingRoom: this.editMeetingForm.WaitingRoom,
                    JoinBeforeHost: this.editMeetingForm.JoinBeforeHost,
                    JoinMute: this.editMeetingForm.JoinMute,
                    WaterPrint: this.editMeetingForm.WaterPrint,
                  })
                  .then((res) => {
                    if (res.code == 200) {
                      this.$message({
                        type: "success",
                        message: "Approve meeting request successfully",
                      });
                      let meetingId = res.data.meetingId||'123';
                      this.$emit("update:visible", false);
                      this.$emit("success",meetingId );
                    } else {
                      this.$message({
                        type: "error",
                        message: res.msg,
                      });
                    }
                    loading.close();
                  })
                  .catch((err) => {
                    loading.close();
                    this.$message({
                      type: "info",
                      message: "error: " + err,
                    });
                  });
              }
              if (!this.status && !this.data) {
                this.axios
                  .post("/meeting/create", {
                    Title: this.editMeetingForm.Title,
                    Status: 0,
                    StartTime:
                      this.editMeetingForm.StartDate +
                      " " +
                      this.editMeetingForm.StartTime,
                    EndTime:
                      this.editMeetingForm.EndDate +
                      " " +
                      this.editMeetingForm.EndTime,
                    CommentDetail: this.editMeetingForm.CommentDetail,
                    Passport: this.editMeetingForm.Password,
                    WaitingRoom: this.editMeetingForm.WaitingRoom,
                    JoinBeforeHost: this.editMeetingForm.JoinBeforeHost,
                    JoinMute: this.editMeetingForm.JoinMute,
                    WaterPrint: this.editMeetingForm.WaterPrint,
                  })
                  .then((res) => {
                    if (res.code == 200) {
                      this.$confirm('您好，会议已创建成功并自动填充到右侧推送中。', '', {
                        confirmButtonText: 'OK',
                        showCancelButton: false,
                        type: 'warning'
                      });
                      this.$emit("update:visible", false);
                      let meetingId = res.data.meetingId||'123';
                      this.$emit("success",meetingId);
                    } else {
                      this.$message({
                        type: "error",
                        message: res.msg,
                      });
                    }
                    loading.close();
                  })
                  .catch((err) => {
                    loading.close();
                    this.$message({
                      type: "info",
                      message: "error: " + err,
                    });
                  });
              }
              if (!this.status && this.data) {
                this.axios
                  .post("/meeting/update", {
                    meetingId: this.editMeetingForm.MeetingId,
                    Title: this.editMeetingForm.Title,
                    Status: this.editMeetingForm.Status,
                    StartTime:
                      this.editMeetingForm.StartDate +
                      " " +
                      this.editMeetingForm.StartTime,
                    EndTime:
                      this.editMeetingForm.EndDate +
                      " " +
                      this.editMeetingForm.EndTime,
                    CommentDetail: this.editMeetingForm.CommentDetail,
                    Password: this.editMeetingForm.Password,
                    WaitingRoom: this.editMeetingForm.WaitingRoom,
                    JoinBeforeHost: this.editMeetingForm.JoinBeforeHost,
                    JoinMute: this.editMeetingForm.JoinMute,
                    WaterPrint: this.editMeetingForm.WaterPrint,
                  })
                  .then((data) => {
                    if (data.code == 200) {
                      this.$message({
                        type: "success",
                        message: "Update meeting successfully",
                      });
                      this.$emit("update:visible", false);
                      // this.$emit("success",meetingId = res.data.reqId||'new');
                      this.$emit("success", "update");
                    } else {
                      this.$message({
                        type: "error",
                        message: data.msg,
                      });
                    }
                    loading.close();
                  })
                  .catch((err) => {
                    loading.close();
                    this.$message({
                      type: "info",
                      message: "error: " + err,
                    });
                  });
              }
            })
            .catch(() => {
              this.dialogVisible = true;
            });
        }
      });
    },
    getMeetingStatus() {
      this.axios.get("/meeting/getStatus").then(({ data }) => {
        this.meetingStatus = data;
      });
    },
  },
};
</script>

<style lang="scss">
.edit-meeting-dialog {
  min-width: 550px;
  .el-scrollbar.dialog {
    max-height: 100%;
    width: 800px;
    min-width: 550px;
    .el-scrollbar__wrap {
      margin-bottom: 0 !important;
    }
  }
  .el-dialog__header {
    padding: 15px;
    .el-dialog__title {
      font-weight: bold;
    }
  }
  .el-dialog__body {
    display: flex;
    padding: 0px;
    max-height: 67vh;
  }
  .el-dialog__footer {
    padding: 10px 15px 15px;
    text-align: center;
  }
  .el-form.form-wrap {
    ::v-deep ul .el-select-dropdown__list {
      list-style: none;
      padding: 6px 0;
      margin: 0;
      box-sizing: border-box;
      text-align: left !important;
    }
    .el-form-item {
      margin-bottom: 15px;
      .el-form-item__label {
        padding: 0;
      }
    }
    .date-picker,
    .time-selecter {
      width: 98%;
    }
    h3 + p {
      margin-top: 5px;
      font-size: 14px;
    }
    .el-row:last-child {
      margin-top: 10px;
    }
    .el-select {
      width: 100%;
    }
    .form-items {
      padding-left: 30px;
    }
    .border-right {
      padding-right: 30px;
      text-align: right;
      border-right: solid #e0e2e4 1px;
      p {
        word-wrap: break-word;
      }
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #606266;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background-color: #d52b1e;
      border-color: #d52b1e;
    }
    h3 {
      position: relative;
      font-size: 18px;
      color: black;
      margin-bottom: 10px;
    }
    h3::after {
      position: absolute;
      right: 0;
      bottom: -4px;
      display: block;
      content: " ";
      height: 2px;
      width: 30px;
      background-color: $theme-color;
    }
    .startP {
      font-size: 12px;
      text-align: left;
      margin-top: -5%;
      color: #ee7765;
      margin-bottom: 1%;
    }
  }
  
  
  
}

// ::v-deep{
    .step-one {
      .el-date-editor.el-input{
        width: 100%;
      }
      .el-form-item--mini.el-form-item{
        .el-form-item__label{
          padding-bottom: 0;
        }
        margin-bottom: 5px;
      }
    }
  // }
</style>
